<template>
  <div style="height: 95vh;">
    <!-- header  -->
    <section
      :class="
        userData.isAndroid
          ? 'padding-nevigate-bar-ANDROID'
          : 'padding-nevigate-bar-IOS'
      "
      v-if="userData.channel != 'WEB'"
    >
      <div class="row no-gutters">
        <div class="col-2 pl-2 justify-content-center align-self-center">
          <div @click="goToPreviousPage()">
            <b-icon
              class="text-kanit-color-black"
              icon="chevron-left"
              style="width: 24px; height: 24px"
            />
          </div>
        </div>
        <div class="col-8 justify-content-center align-self-center">
          <div class="mx-0 text-center font-kanit-bold-20">
            {{ this.currentMenu.pageName }}
          </div>
        </div>
        <div class="col-2 px-0"></div>
      </div>
    </section>

    <div
      class="justify-content-md-center p-3 d-flex flex-column justify-content-between h-100"
      :style="userData.isAndroid ? '' : 'overflow-y: scroll;'"
    >
      <div>
        <!-- Imaage -->
        <div class="row">
          <div class="col-md-4 justify-content-center align-self-center">
            <div class="">
              <div class="row" style="">
                <div
                  class="offset-2 col-8 offset-md-1 col-md-10 justify-content-center align-self-center"
                >
                  <template>
                    <b-img-lazy
                      center
                      class="image"
                      :src="imgBgNEXT"
                      width="240"
                      height="168"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="justify-content-center" v-if="haveDocRequire().length > 0">
          <b-row class="pb-3">
            <b-col class="font-kanit-bold-16 text-kanit-color-black">
              {{ "เอกสารที่จำเป็น" }}
            </b-col>
          </b-row>

          <div
            class="mb-3 justify-content-md-center"
            v-for="(item, key) in haveDocRequire()"
            :key="key"
          >
            <div v-if="!item.deviate_flag">
              <b-card
                class="border-radius-1rem"
                body-class="body-landing py-3"
                @click="doDetail(item.doc_code)"
              >
                <b-row style="line-height: 32px">
                  <b-col cols="1" align-self="center">
                    <template v-if="item.state == 'attachfile'">
                      <b-img
                        center
                        :src="iconUploadated"
                        width="32"
                        height="32"
                      ></b-img>
                    </template>
                    <template v-else-if="item.state == 'success'">
                      <b-img
                        center
                        :src="iconUploadsSuccess"
                        width="32"
                        height="32"
                      ></b-img>
                    </template>
                    <template v-else-if="item.state == 'error'">
                      <b-img
                        center
                        :src="iconUploadsError"
                        width="32"
                        height="32"
                      ></b-img>
                    </template>
                    <template
                      v-else-if="item.state == 'uploading' && item.progress > 0"
                    >
                      <b-img
                        center
                        :src="iconUploading"
                        width="32"
                        height="32"
                      ></b-img>
                    </template>
                    <template v-else-if="item.state == 'uploading'">
                      <b-img
                        center
                        :src="iconUploading"
                        width="32"
                        height="32"
                      ></b-img>
                    </template>
                    <template v-else>
                      <b-badge pill class="badge-wait"
                        ><span
                          class="font-kanit-bold-16"
                          style="line-height: 32px"
                        >
                          {{ key + 1 }}
                        </span></b-badge
                      >
                    </template>
                  </b-col>
                  <b-col
                    class="text-left"
                    style="padding-left: 32px !important"
                    col
                  >
                    <b-row>
                      <b-col
                        col
                        :style="
                          item.state == 'attachfile' || item.state == 'error'
                            ? 'line-height: 1;'
                            : ''
                        "
                      >
                        <span class="font-kanit-regular-16">{{
                          item.doc_short_name
                        }}</span>
                        <template
                          v-if="
                            item.state == 'attachfile' ||
                            item.state == 'error' ||
                            item.state == 'wait'
                          "
                        >
                          <div class="w-100" />

                          <span
                            v-if="item.state == 'attachfile'"
                            class="font-kanit-regular-14 text-kanit-color-blue"
                          >
                            แนบเอกสารแล้ว รอกดอัปโหลด
                          </span>

                          <span
                            v-if="item.state == 'error'"
                            class="font-kanit-regular-14 text-kanit-color-danger"
                          >
                            อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง
                          </span>

                          <span
                            v-if="
                              item.state == 'wait' && getHistory(item.doc_code)
                            "
                            class="font-kanit-regular-14 text-kanit-color-orange"
                          >
                            กรุณาอัปโหลดเอกสารใหม่
                          </span>
                        </template>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    cols="1"
                    class="px-0"
                    align-self="center"
                    style="line-height: 32px"
                  >
                    <b-icon
                      icon="chevron-right"
                      font-scale="1.3"
                      style="color: #838383;"
                    />
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </div>
        </div>

        <div
          v-if="haveDocDeviate().length > 0"
          class="justify-content-center"
          style="margin-top: 24px !important"
        >
          <b-row class="pb-3">
            <b-col class="font-kanit-bold-16 text-kanit-color-black">
              {{ "เอกสารเพิ่มเติม" }}
            </b-col>
          </b-row>

          <div>
            <div
              class="mb-3 justify-content-md-center"
              v-for="(item, key) in haveDocDeviate()"
              :key="key"
            >
              <div v-if="item.deviate_flag">
                <b-card
                  class="border-radius-1rem"
                  body-class="body-landing py-3"
                  @click="doDetail(item.doc_code)"
                >
                  <b-row style="line-height: 32px">
                    <b-col cols="1" align-self="center">
                      <template v-if="item.state == 'attachfile'">
                        <b-img
                          center
                          :src="iconUploadated"
                          width="32"
                          height="32"
                        ></b-img>
                      </template>
                      <template v-else-if="item.state == 'success'">
                        <b-img
                          center
                          :src="iconUploadsSuccess"
                          width="32"
                          height="32"
                        ></b-img>
                      </template>
                      <template v-else-if="item.state == 'error'">
                        <b-img
                          center
                          :src="iconUploadsError"
                          width="32"
                          height="32"
                        ></b-img>
                      </template>
                      <template
                        v-else-if="
                          item.state == 'uploading' && item.progress > 0
                        "
                      >
                        <b-img
                          center
                          :src="iconUploading"
                          width="32"
                          height="32"
                        ></b-img>
                      </template>
                      <template v-else-if="item.state == 'uploading'">
                        <b-img
                          center
                          :src="iconUploading"
                          width="32"
                          height="32"
                        ></b-img>
                      </template>
                      <template v-else>
                        <b-badge pill class="badge-wait"
                          ><span
                            class="font-kanit-bold-16"
                            style="line-height: 32px"
                          >
                            {{ key + 1 + haveDocRequire().length }}
                          </span></b-badge
                        >
                      </template>
                    </b-col>
                    <b-col
                      class="text-left"
                      style="padding-left: 32px !important"
                      col
                    >
                      <b-row>
                        <b-col
                          col
                          :style="
                            item.state == 'attachfile' || item.state == 'error'
                              ? 'line-height: 1;'
                              : ''
                          "
                        >
                          <span class="font-kanit-regular-16"
                            >{{ item.doc_short_name }}{{ " (ถ้ามี)" }}</span
                          >
                          <template
                            v-if="
                              item.state == 'attachfile' ||
                              item.state == 'error' ||
                              item.state == 'wait'
                            "
                          >
                            <div class="w-100" />

                            <span
                              v-if="item.state == 'attachfile'"
                              class="font-kanit-regular-14 text-kanit-color-blue"
                            >
                              แนบเอกสารแล้ว รอกดอัปโหลด
                            </span>

                            <span
                              v-if="item.state == 'error'"
                              class="font-kanit-regular-14 text-kanit-color-danger"
                            >
                              อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง
                            </span>

                            <span
                              v-if="
                                item.state == 'wait' &&
                                getHistory(item.doc_code)
                              "
                              class="font-kanit-regular-14 text-kanit-color-orange"
                            >
                              กรุณาอัปโหลดเอกสารใหม่
                            </span>
                          </template>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col
                      cols="1"
                      class="px-0"
                      align-self="center"
                      style="line-height: 32px"
                    >
                      <b-icon
                        icon="chevron-right"
                        font-scale="1.3"
                        style="color: #838383;"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </div>
          </div>
        </div>

        <div class="justify-content-center">
          <div class="mt-3 justify-content-md-center">
            <b-card
              class="border-radius-1rem mt-2 sector-info-document"
              body-class="py-1 mb-2"
            >
              <b-row class="pt-1">
                <b-col cols="1">
                  <b-img :src="iconInfo" width="16" height="16"></b-img>
                </b-col>
                <b-col class="pl-0" style="padding-left: 16px !important">
                  <span
                    class="font-kanit-regular-16 text-kanit-color-black"
                    style="line-height: 24px"
                    >เอกสารเพิ่มเติมจะช่วยเพิ่มโอกาสในการพิจารณาสินเชื่อ
                  </span>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
      </div>
      <div v-if="userData.isDocumentType && listDoc.state !== 'success'">
        <b-row>
          <b-col>
            <button
              class="btn btn-block btn-submit-landing-page"
              @click="goback()"
              :disabled="!checkFileRequire()"
            >
              <template v-if="'RESUBMIT' != userData.followupStatus.code">
                แนบเอกสาร
              </template>
              <template v-else> แนบเอกสารทั้งหมด </template>
            </button>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- modal back-->

    <b-modal
      v-model="modalShowBackStep"
      hide-header
      hide-header-close
      hide-footer
      content-class="content-dialog-back"
    >
      <div class="justify-content-center py-4">
        <b-row>
          <b-col style="text-align: center"
            ><span class="font-kanit-bold-20 text-kanit-color-black"
              >ยืนยันการออกจากหน้านี้?</span
            ></b-col
          >
        </b-row>
        <b-row class="pt-2">
          <b-col style="text-align: center">
            <span class="font-kanit-regular-16 text-kanit-color-black"
              >ข้อมูลของคุณจะไม่ถูกบันทึก</span
            ></b-col
          >
        </b-row>

        <b-row class="pt-4">
          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
              @click="modalShowBackStep = !modalShowBackStep"
            >
              <span class="">ยกเลิก</span>
            </b-button>
          </b-col>

          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-confirm-file-duplication"
              @click="clearData()"
            >
              <span class="">ออกจากหน้านี้</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  computed: {
    userDataStores() {
      return this.$store.state.userData;
    },
  },
  data() {
    return {
      imgBgNEXT: require("@/assets/images/ic_upload.png"),
      imgArrowRight: require("@/assets/images/foundationIconSimpleSystemArrowRight@3x.png"),
      docList: [],
      userData: {},
      size: 0,
      files: [],
      realFiles: [],
      listDoc: [],
      grpId: null,
      iconUploadsError: require("@/assets/images/ic_landing_error.png"),
      iconUploadsSuccess: require("@/assets/images/ic_landing_success.png"),
      iconUploading: require("@/assets/images/foundationIconSimpleComponentSnackbarUpload.png"),
      iconUploadated: require("@/assets/images/ic_landing_uploaded.png"),
      iconInfo: require("@/assets/images/ic_info.png"),
      currentMenu: {},
      modalShowBackStep: false,
    };
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.userData = this.$store.getters.getUserData;
    this.grpId = this.userData.grpId;
    this.currentMenu = {
      pageCode: "CommonPreUpload",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == this.grpId
      ).grp_name,
      previousPage: this.userData.routerPath.landing,
      isShow: true,
    };
    this.$event.$emit("update_current_menu", this.currentMenu);

    if (!this.userData.token)
      this.$router.push(this.userData.routerPath.landing);

    window.onMobileBackPressed = function () {
      console.log("onMobileBackPressed");
      this.goToPreviousPage();
      return true;
    };
  },
  mounted() {
    this.initData();
    //Order Display
    if (this.files.filter((item) => !item.deviate_flag).length > 0)
      this.GroupDocDisplay.push(
        this.files.filter((item) => !item.deviate_flag)
      );
    if (this.files.filter((item) => item.deviate_flag).length > 0)
      this.GroupDocDisplay.push(this.files.filter((item) => item.deviate_flag));
  },
  methods: {
    initData() {
      this.listDoc = this.userData.document_group_type.find(
        (v) => v.grp_id == this.grpId
      );

      for (var i = 0; i < this.listDoc.lst_doc_id.length; i++) {
        for (var j = 0; j < this.userData.documentType.length; j++) {
          if (
            this.userData.documentType[j].doc_code == this.listDoc.lst_doc_id[i]
          ) {
            this.docList.push(this.userData.documentType[j]);
          }
        }
      }
      if (this.docList.length == 1 && this.docList[0].state != "deviate") {
        if (this.$route.params.action == "NEXT") {
          this.doDetail(this.docList[0].doc_code);
        } else {
          this.$router.push({
            name: this.userData.routerPath.landing,
          });
        }
      }
    },
    goToPreviousPage() {
      if (this.listDoc.state == "success") {
        this.goback();
        return;
      }

      if (
        this.listDoc.lst_doc_id.length ==
        this.docList.filter((d) => d.filesReal.length <= 0).length
      ) {
        this.goback();
        return;
      }

      this.modalShowBackStep = true;
    },
    clearData() {
      this.docList.forEach((v) => {
        const docTypeBean = this.userDataStores.documentType.find(
          (docType) =>
            docType.doc_code == v.doc_code && docType.state != "success"
        );
        if (docTypeBean != undefined) {
          docTypeBean.realFiles = [];
          docTypeBean.filesReal = [];
          docTypeBean.state = "wait";
        }
      });
      this.goback();
    },
    goback() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    getHeader() {
      return this.listDoc.grp_name;
    },
    doDetail(doc_code) {
      this.$router.push({
        name: this.userData.routerPath.upload,
        params: { doc_code: doc_code, grpId: this.grpId },
      });
    },
    getListFileByType() {
      return this.realFiles;
    },
    cancel() {
      this.$router.push(this.userData.routerPath.landing);
    },
    haveDocRequire() {
      return this.docList.filter(
        (item) => !item.deviate_flag && item.state != "deviate"
      );
    },
    haveDocDeviate() {
      return this.docList.filter(
        (item) => item.deviate_flag && item.state != "deviate"
      );
    },
    checkFileRequire() {
      let check = 0;
      this.docList.forEach((v) => {
        if (!v.deviate_flag && v.filesReal.length != 0) {
          check++;
        }
      });

      return this.docList.filter((v) => !v.deviate_flag).length == check;
    },
    getHistory(doc_code) {
      let history = this.userData.historyUploads.find(
        (i) => i.doc_code == doc_code
      );
      return history.doc_upload_date !== null;
    },
    getSizeFileUploadsMB(realFiles) {
      let bytes = 0;
      realFiles.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return (bytes / (1024 * 1024)).toFixed(1);
    },
    calMarginTop() {
      var h = window.innerHeight;
      let defaultVal = 40;
      if (h < 800) defaultVal = defaultVal - 25;
      if (this.docList.length != 0) {
        defaultVal = defaultVal - 5 * this.docList.length;
      }
      if (defaultVal < 0) return 0;
      return defaultVal;
    },
  },
};
</script>

<style>
a {
  color: black;
  text-decoration: none;
}
a:hover,
a:focus {
  color: black;
  text-decoration: none;
}
.deviate-text {
  color: #ff6961;
  font-size: 0.75rem;
}
.document-info > .title {
  color: #00a3e4;
}
.document-info > .header {
  color: #000000;
}
.document-info > .body {
  color: #8e94a4;
}
.btn-upload-true {
  background-color: #e3e4e8 !important;
  color: #aaafbb !important;
  border-color: #e3e4e8 !important;
}
.btn-ktb-deviate {
  background-color: white !important;
  color: #df0747 !important;
  border-color: #f93972 !important;
}
.btn-goback {
  background-color: white !important;
  color: #00a3e4 !important;
  border-color: #00a3e4 !important;
}
.text-upload-true {
  color: #aaafbb !important;
}
.alert-warning {
  color: #b98f13;
  background-color: #fdf8e7;
  border-color: #ffeeba;
  border-left-color: #f5d470;
  border-left-width: 4px;
}
.spin {
  animation-name: spin;
  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.status-color-2 {
  color: #daa60b !important;
}
.status-color-3 {
  color: #479e6a !important;
}
.status-color-6 {
  color: #aaafbb !important;
}
.status-color-5,
.status-color-1,
.status-color-4 {
  color: #df0747 !important;
}
.text-right {
  text-align: right;
}
.text-wait-upload {
  color: #e4ba00;
}
.text-upload {
  color: rgb(99, 190, 0);
}
.text-upload-error {
  color: rgb(219, 0, 0);
}
.header-group-doc {
  font-size: 20px;
}
.body-landing {
  padding-left: 1rem;
  padding-right: 1rem;
}
.badge-wait {
  border: 1.5px solid #f8f8f8 !important;
  box-sizing: border-box;
  color: #cacaca !important;
  background-color: #f8f8f8;
  width: 32px;
  height: 32px;
  margin-left: 1%;
}
.sector-info-document {
  background: #f2f2f2 !important;
  border-radius: 8px !important;
  border: 1px solid #f2f2f2 !important;
}
</style>
